module.exports = __webpack_public_path__ + "img/buy-product.f48ba062.jpeg";